import links from '../../../links'
import constants from '../../../constants'
import filterNav from '../../../modifiers/filterNav'
import getNotEmptyCosmeticsCategories from '../../getNotEmptyCosmeticsCategories'

import messages from './messages'


const { personalCare: { categories: personalCareCategories } } = constants.cosmeticsCategories
const { personalCare: personalCareTypes } = constants.cosmeticsProductTypes

const getPersonalCareTypes = (values) => {
  const { notEmptyTypes, withoutAll } = values

  const categories = [
    (
      !withoutAll && (
        { name: personalCareCategories.all, title: messages.all, to: links.personalCare }
      )
    ),
    ...(
      getNotEmptyCosmeticsCategories({
        root: constants.cosmeticsCategories.personalCare.name,
        types: notEmptyTypes,
        categories: [
          {
            name: personalCareCategories.bodyMoisturizers,
            title: messages.bodyMoisturizers,
            to: links.personalCareBodyMoisturizers,
            singleType: personalCareTypes.bodyMoisturizers.bodyMoisturizers,
          },
          {
            name: personalCareCategories.handCreams,
            title: messages.handCreams,
            to: links.personalCareHandCreams,
            singleType: personalCareTypes.handCreams.handCreams,
          },
          {
            name: personalCareCategories.shower,
            title: messages.shower,
            to: links.personalCareShower,
            subCategories: [
              {
                name: personalCareTypes.shower.bodyWash,
                title: messages.bodyWash,
                to: `${links.personalCareShowerBodyWash}`,
              },
              {
                name: personalCareTypes.shower.bodyScrubs,
                title: messages.bodyScrubs,
                to: `${links.personalCareShowerBodyScrub}`,
              },
            ],
          },
        ],
      })
    ),
  ]

  // Remove "false" elements [ {..}, false, {..} ] -> [ {..}, {..} ]
  const filteredCategories = categories
    .filter((category) => Boolean(category))
    .map((category) => {
      const { subCategories } = category

      if (Boolean(subCategories)) {
        category.subCategories = subCategories.filter((subCategory) => Boolean(subCategory))
      }

      return category
    })

  return filterNav(filteredCategories, 'subCategories')
}


export default getPersonalCareTypes
